<script setup lang="ts">
import { Sign as SignInterface } from '@/models/sign'
import { can } from '@layouts/plugins/casl'

// import Snackbar
import { useSnackbarStore } from '@/store/snackbar'

interface IProps {
  sign?: SignInterface,
  showSidebar?: boolean,
  showGlobalChatDialog?: boolean,
  showSignStatusHistoryDialog?: boolean,
}

const props = withDefaults(defineProps<IProps>(), {
  sign: () => ({}),
  showSidebar: false,
  showGlobalChatDialog: false,
  showSignStatusHistoryDialog: false,
})

interface CustomEvents {
  (e: 'update:showSidebar', value: boolean): void
  (e: 'update:showGlobalChatDialog', value: boolean): void
  (e: 'update:showSignStatusHistoryDialog', value: boolean): void
  (e: 'updateSignArtworkInfo', value: any): void
}

const emit = defineEmits<CustomEvents>()

const snackbarStore = useSnackbarStore()
</script>

<template>
  <div class="d-flex flex-wrap align-center py-1">
    <span class="mr-1">
      {{ sign?.short_name }}
    </span>
    <div>
      <VBtn
        size="small"
        variant="elevated"
        density="compact"
        icon="tabler-history-toggle"
        class="ml-1 rounded-lg"
        @click="emit('update:showSignStatusHistoryDialog', !showSignStatusHistoryDialog)"
      >
        <VIcon icon="tabler-history-toggle" />
        <VMenu
          activator="parent"
          location="top center"
          open-on-hover
          open-delay="100"
          close-delay="0"
          offset="5"
          class="default-tooltip"
        >
          <span class="px-2">
            Status History
          </span>
        </VMenu>
      </VBtn>
    </div>
    <div>
      <VBtn
        size="small"
        variant="elevated"
        density="compact"
        icon="tabler-activity-heartbeat"
        class="ml-1 rounded-lg"
        @click="emit('update:showSidebar', !showSidebar)"
      >
        <VIcon icon="tabler-activity-heartbeat" />
        <VMenu
          activator="parent"
          location="top center"
          open-on-hover
          open-delay="100"
          close-delay="0"
          offset="5"
          class="default-tooltip"
        >
          <span class="px-2">
            Activity Timeline
          </span>
        </VMenu>
      </VBtn>
    </div>
    <div>
      <VBtn
        size="small"
        variant="elevated"
        density="compact"
        icon="tabler-bubble-text"
        class="ml-1 rounded-lg"
        @click="emit('update:showGlobalChatDialog', !showGlobalChatDialog)"
      >
        <VIcon icon="tabler-bubble-text" />
        <VMenu
          activator="parent"
          location="top center"
          open-on-hover
          open-delay="100"
          close-delay="0"
          offset="5"
          class="default-tooltip"
        >
          <span class="px-2">
            Chat
          </span>
        </VMenu>
      </VBtn>
    </div>
  </div>
</template>

<style lang="scss">
</style>
